import type { TRegion } from 'types/countries';
import { createRequestHeaders } from 'utils/request';
import { $fetch } from 'utils/request';
import { COUNTRIES_ROUTE, REGIONS_AND_CITIES } from 'utils/routes';
import { defaultLocale } from 'utils/translations';

export type TCountry = {
  id: string;
  name: string;
  languages: {
    id: string;
    name: string;
    default: boolean;
  }[];
  globale: boolean;
  esw: boolean;
};
type GetCountriesReturn = {
  countries: TCountry[];
};

export async function getCountries({ locale = defaultLocale }: { locale?: string }) {
  try {
    const r = await $fetch<GetCountriesReturn>({ path: COUNTRIES_ROUTE, query: { profile: locale } });
    return r;
  } catch (error) {
    return null;
  }
}

type GetRegionsAndCitiesReturn = {
  regions: TRegion[];
  cities: string[];
};

export async function getRegionsAndCities({ locale }: { locale: string }): Promise<GetRegionsAndCitiesReturn> {
  try {
    return await $fetch<GetRegionsAndCitiesReturn>({ path: REGIONS_AND_CITIES, query: { profile: locale } });
  } catch (error) {
    return {
      regions: [],
      cities: [],
    } as GetRegionsAndCitiesReturn;
  }
}
